import { request } from "../utils/request";
import { BACKEND_BASE_URL } from "./Resolver";
import { APIResource } from "./Resource";

export class TranscoderTemplateUpload extends APIResource {
  baseURL = `${BACKEND_BASE_URL}/api/v1/transcoder-templates`;
  upsertFields = ["JSONPayload"];

  payload: string;

  constructor(payload: string) {
    super();
    this.payload = payload;
  }

  public name__validation(value: string): string | undefined {
    if (this.payload && !value) return "Should not be empty after providing the JSON Object.";
  }

  JSONPayload__validation(value: string): string | undefined {
    if (!value) return "Invalid JSON";
  }

  get id(): string {
    return this.name;
  }

  set id(value: string) {
    // Since id is abstract method, we should implement both get and set.
    // Since we will not set id using this class, we can ignore it.
    return;
  }

  get name(): string {
    return this.JSONPayload?.name ?? "";
  }

  set name(value: string | undefined) {
    const payload = this.JSONPayload || {};
    payload.name = value;
    this.payload = JSON.stringify(payload, null, " ");
  }

  get JSONPayload(): any {
    try {
      return JSON.parse(this.payload);
    } catch (objError) {
      return null;
    }
  }

  getUpsertJSON(): string {
    return JSON.stringify(this.JSONPayload);
  }
}

export class TranscoderTemplate {
  private static transcoderTemplateBaseURL = `${BACKEND_BASE_URL}/api/v1/transcoder-templates`;

  static async retrieve(name: string) {
    const url = new URL(`${this.transcoderTemplateBaseURL}/${name}`);
    const response = await request(url, { method: "GET" }, true);
    return await response?.json();
  }

  static async delete(name: string) {
    const url = new URL(`${this.transcoderTemplateBaseURL}/${name}`);
    await request(url, { method: "DELETE" }, true);
  }
}
